import PropTypes from 'prop-types'

/**
 * @typedef {Object} VehicleSpecificationBrand
 *
 * @property {string}  [brandId]    - Vehicle brand ID
 * @property {string}  [brandName]  - Vehicle brand name
 * @property {string}  [createTime] - The creation time
 * @property {string}  [modifyTime] - Row modify time
 */
export const vehicleSpecificationBrandPropType = PropTypes.shape({
    brandId: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    createTime: PropTypes.string,
    modifyTime: PropTypes.string
})
